/**
 * Remembers the branch a user last chose, per tenant and user, so a reload or a session re-check does not
 * drop them onto whichever branch the server lists first. Only branches the session currently grants are
 * ever chosen; a stale or revoked branch falls back to the first granted one. Storage failures (private
 * mode, blocked storage) silently fall back to the first branch.
 */
type BranchUser={id:string;tenantId:string;branches:{id:string}[]};
type KeyValueStore={getItem(key:string):string|null;setItem(key:string,value:string):void;removeItem(key:string):void};

const keyFor=(u:BranchUser)=>`esaas.branch.${u.tenantId}.${u.id}`;
const browserStore=():KeyValueStore|null=>{try{return typeof window==='undefined'?null:window.localStorage}catch{return null}};

export function chooseBranch(u:BranchUser,current:string,store:KeyValueStore|null=browserStore()):string{
 const granted=new Set(u.branches.map(b=>b.id));
 if(current&&granted.has(current))return current;
 let remembered:string|null=null;
 try{remembered=store?.getItem(keyFor(u))??null}catch{remembered=null}
 if(remembered&&granted.has(remembered))return remembered;
 return u.branches[0]?.id||'';
}

export function rememberBranch(u:BranchUser,branchId:string,store:KeyValueStore|null=browserStore()):void{
 try{
  if(branchId)store?.setItem(keyFor(u),branchId);
  else store?.removeItem(keyFor(u));
 }catch{/* storage unavailable: the branch still applies for this page */}
}
